import { useEffect, useState } from 'react';

import { Header } from '@tanstack/react-table';

export const useColumnResize = <TData,>(header: Header<TData, unknown>) => {
  const [isHovered, setIsHovered] = useState(false);
  const isResizing = header.column.getIsResizing();

  const handleMouseEnter = () => {
    setIsHovered(true);
  };

  const handleMouseLeave = () => {
    if (!isResizing) {
      setIsHovered(false);
    }
  };

  // Reset hover state when resizing ends
  useEffect(() => {
    if (!isResizing) {
      setIsHovered(false);
    }
  }, [isResizing]);

  const isVisible = isHovered || isResizing;

  return {
    isVisible,
    isResizing,
    handleMouseEnter,
    handleMouseLeave,
    resizeHandler: header.getResizeHandler()
  };
};

